import React from "react"
export function Email(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <path
        d="M19 15.501c0 .38-.29.694-.667.743l-.104.007H1.77a.765.765 0 01-.764-.648L1 15.5V4.461l.017-.118a.754.754 0 01.645-.585l.11-.007h16.457c.339 0 .592.195.706.448l.027.07.03.117.008.075V15.5zm-7.051-4.662l-1.441 1.227a.789.789 0 01-.925.066l-.091-.066-1.44-1.226-4.599 3.91h13.093l-4.597-3.91zm5.508-4.686l-4.337 3.69 4.337 3.69v-7.38zM6.88 9.843l-4.337-3.69v7.38l4.337-3.69zm9.296-4.592H3.823L10 10.504l6.176-5.253z"
        fill="currentColor"
        fillRule="nonzero"
        id="prefix__email"
        stroke="none"
        strokeWidth={1}
      />
    </svg>
  )
}
